import { TableCell, TableRow, Alert } from "@mui/material";
import { ITableColumn } from "../../../../App/Typings/Table";
import { useHistory } from "react-router-dom";
import { Check, Error, ErrorOutline } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { updateCurrentTab } from "../../../../App/State/Slices/TabGroupSlice";

const classes = {
  rowCell: {
    cursor: "pointer !important",
    backgroundColor: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  itemIcon: {
    cursor: "grab",
  },
  tableCell: {
    color: "primary.copy",
  },
};

interface IAppsTabelCellProps {
  columns: ITableColumn[];
  element: any;
}

export default function AppsTableCell({
  columns,
  element,
}: IAppsTabelCellProps) {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(updateCurrentTab("App Details"));
    history.push(`/abac/${element.id}`);
  };

  return (
    <>
      <TableRow
        hover
        key={element.id}
        sx={classes.rowCell}
        onClick={() => handleClick()}
      >
        {columns.map((column: ITableColumn, elementIndex: number) => {
          let value = element[column.propName];
          if (value instanceof Date) {
            value = value.toLocaleDateString("en-US");
          }
          return (
            <TableCell key={elementIndex} align="left" sx={classes.tableCell}>
              {column.propName === "isActive" ? (
                element.isActive ? (
                  <Check sx={{ ml: "10%", color: "primary.main" }} />
                ) : (
                  <ErrorOutline sx={{ ml: "10%", color: "secondary.main" }} />
                )
              ) : (
                value
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </>
  );
}
